import Docs from '../../../content/Docs';

//-- private is a reserved word, so use secured instead

const releaseRoutes = [
	{
		id: 'docs',
		name: 'docs',
		paths: ['/docs', '/documentation'],
		exact: true,
		component: Docs,
		meta: {
			enabled: true,
			secured: true,
			roles: [],
			showInNav: true,
			showBreadcrumb: true,
			linkText: 'Docs',
			icon: <i className='las la-book'></i>,
			level: 1,
			children: null,
			signIn: false,
			signOut: false,
			authCallback: false,
			setupRequired: false,
			unauthorized: false,
			loginFailed: false,
			httpError: false,
			pageNotFound: false,
			home: false,
			content: true,
			settings: false
		}
	}
];

export default releaseRoutes;
